import React from 'react';
import {
  Box,
  Button,
  Chip,
  Divider,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  CARD_SX,
  ICON_INDIGO,
  fieldSx,
  LOG_STEP_OPTIONS,
} from '../pages/logsPage.utils';

export default function LogsFiltersPanel({
  restaurantes,
  filterRestaurante,
  setFilterRestaurante,
  filterLevel,
  setFilterLevel,
  filterOrigin,
  setFilterOrigin,
  filterIgnored,
  setFilterIgnored,
  filterPhone,
  setFilterPhone,
  filterStep,
  setFilterStep,
  filterTraceId,
  setFilterTraceId,
  groupByPhone,
  setGroupByPhone,
  handleClearFilters,
}) {
  return (
    <Fade in timeout={600}>
      <Box sx={{ ...CARD_SX, overflow: 'visible' }}>
        <Box sx={{ p: { xs: 2, sm: 2.5 } }}>
          <Stack direction="row" alignItems="center" gap={1.25} mb={1.5}>
            <Box sx={ICON_INDIGO}><FilterListIcon sx={{ fontSize: 18 }} /></Box>
            <Typography fontWeight={700} sx={{ color: '#0f172a', fontSize: '0.975rem', letterSpacing: '-0.01em' }}>
              Filtros
            </Typography>
          </Stack>
          <Divider sx={{ mb: 2, borderColor: 'rgba(15,23,42,0.06)' }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel>Restaurante</InputLabel>
                <Select
                  value={filterRestaurante}
                  label="Restaurante"
                  onChange={(e) => setFilterRestaurante(e.target.value)}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  {restaurantes.map((rest) => (
                    <MenuItem key={rest.id} value={rest.id}>
                      {rest.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                select
                label="Nível"
                value={filterLevel}
                onChange={(e) => setFilterLevel(e.target.value)}
                size="small"
                fullWidth
                sx={fieldSx}
              >
                <MenuItem value="ALL">Todos</MenuItem>
                <MenuItem value="INFO">INFO</MenuItem>
                <MenuItem value="WARN">WARN</MenuItem>
                <MenuItem value="ERROR">ERROR</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="Origem"
                value={filterOrigin}
                onChange={(e) => setFilterOrigin(e.target.value)}
                size="small"
                fullWidth
                sx={fieldSx}
              >
                <MenuItem value="ALL">Clientes e Restaurantes</MenuItem>
                <MenuItem value="CLIENTE">Somente clientes</MenuItem>
                <MenuItem value="RESTAURANTE">Somente restaurantes</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="Tipo"
                value={filterIgnored}
                onChange={(e) => setFilterIgnored(e.target.value)}
                size="small"
                fullWidth
                sx={fieldSx}
              >
                <MenuItem value="ALL">Todos</MenuItem>
                <MenuItem value="VALID">Válidos</MenuItem>
                <MenuItem value="IGNORED">Ignorados</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Telefone"
                value={filterPhone}
                onChange={(e) => setFilterPhone(e.target.value)}
                size="small"
                fullWidth
                placeholder="Ex: 5511999999999"
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel>Etapa (Step)</InputLabel>
                <Select
                  multiple
                  value={filterStep}
                  label="Etapa (Step)"
                  onChange={(e) => setFilterStep(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} size="small" />
                      ))}
                    </Box>
                  )}
                >
                  {LOG_STEP_OPTIONS.map((step) => (
                    <MenuItem key={step} value={step}>
                      {step}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Trace ID"
                value={filterTraceId}
                onChange={(e) => setFilterTraceId(e.target.value)}
                size="small"
                fullWidth
                placeholder="ID da Mensagem"
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={<Switch checked={groupByPhone} onChange={(e) => setGroupByPhone(e.target.checked)} />}
                  label="Agrupar por Telefone"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                sx={{ height: '100%' }}
              >
                <Button
                  variant="text"
                  startIcon={<FilterListIcon />}
                  onClick={handleClearFilters}
                  sx={{
                    color: '#475569', fontWeight: 600, borderRadius: '12px',
                    '&:hover': { background: 'rgba(99,102,241,0.08)', color: '#6366f1' },
                  }}
                >
                  Limpar filtros
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fade>

  );
}
